<template>
  <v-container>
    <v-sheet class="mb-2 d-flex justify-space-around">
      <v-btn outlined color="grey darken-2" @click="setToday" small>{{ $t('label.today') }}</v-btn>
      <h3 flat>{{ getName() }}{{ getAgeMonth() }}</h3>
      <v-menu bottom right mall>
        <template v-slot:activator="{ on }">
          <v-btn outlined color="grey darken-2" v-on="on" small>
            <span>{{ $t(typeToLabel[type]) }}</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="type = 'day'">
            <v-list-item-title>{{ $t('label.day') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'week'">
            <v-list-item-title>{{ $t('label.week') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="type = 'month'">
            <v-list-item-title>{{ $t('label.month') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
    <v-sheet height="32px">
      <v-toolbar flat color="white" height="30px" class="d-flex justify-space-around">
        <v-btn fab text large color="grey darken-2" @click="prev">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title small>{{ title }}</v-toolbar-title>
        <v-btn fab text large color="grey darken-2" @click="next">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-sheet>
    <v-row class="text-center">
      <v-col cols="12">
        <v-calendar
          ref="calendar"
          v-model="focus"
          locale="ja-jp"
          :day-format="timestamp => new Date(timestamp.date).getDate()"
          color="#EEEEEE"
          :weekdays="weekday"
          :events="events"
          :event-color="getEventColor"
          :now="today"
          :type="type"
          :event-more="false"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
      </v-col>
    </v-row>

    <div class="menu" v-if="hasFocus()">
      <div class="menu-title text-center">
        <div class="d-flex justify-space-around mb-6" outlined tile>
          <h3>
            {{ formatFocus() }}{{ $t('title.add-menu') }}
          </h3>
          <v-btn
            absolute
            class="btn-add-menu"
            dark
            fab
            right
            depressed
            color="pink"
            :to="{ name: 'Menu', params: {id: this.$util.generateHash() }}"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="date-nutrients" v-if="0 < dateNutrients.length">
        <div class="d-flex justify-space-around mb-2">
          {{ $t('todays-nutrients') }}
        </div>
        <div class="d-flex justify-space-around mb-6">
          <div v-for="(item, key) in dateNutrients" :key="key">
            <img class="nutrients-icon" v-bind:src="item.icon">
          </div>
        </div>
      </div>
      <div class="date-menu">
        <v-card v-for="(item, i) in dateItems" :key="i" :to="{ name: 'Menu', params: {id: item.hash }}" outlined tile>
          <v-row class="menu-list-row">
            <v-col cols="3">
              <div class="text-center">{{ $util.extractTime(item.start) }}</div>
              <div class="text-center time-duration">～</div>
              <div class="text-center">{{ $util.extractTime(item.end) }}</div>
            </v-col>
            <v-col cols="9">
              <div>
                <p v-if="item.hasAllergy" class="pa-1 has-allergy">
                  <span class="font-weight-bold">
                    {{ item.name }}
                  </span>
                  <span v-if="item.unit" class="pa-1">
                    {{ formatAmount(item) }}
                  </span>
                </p>
                <p v-else class="pa-1">
                  <span class="font-weight-bold">
                    {{ item.name }}
                  </span>
                  <span v-if="item.unit" class="pa-1">
                    {{ formatAmount(item) }}
                  </span>
                </p>
              </div>
              <div class="menu-nutrient">
                <div :class="`d-flex justify-start`" outlined tile>
                  <div v-for="(nutrientId, key) in item.nutrients" :key="key" class="mr-5">
                    <img v-bind:src="$nutrients.getIcon(nutrientId)" class="nutrients-icon">
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <div class="menu" v-else>
      <div class="menu-title text-center">
        <div class="d-flex justify-space-around mb-6" outlined tile>
          <p>
            {{ $t('msg.choice-calendar') }}
          </p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    menuOpen: false,
    today: null,
    focus: null,
    type: "month",
    typeToLabel: {
      month: "label.month",
      week: "label.week",
      day: "label.day"
    },
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    weekday: [0, 1, 2, 3, 4, 5, 6],
    // weekday: [1, 2, 3, 4, 5, 6, 0],
    weekdays: [
      { text: "日 - 土", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "月 - 日", value: [1, 2, 3, 4, 5, 6, 0] }
    ],
    events: [],
    dateItems: [],
    dateNutrients: [],
    dummies: null
  }),
  computed: {
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? "" : endMonth
      const startYear = start.year + this.nyear()
      const endYear = end.year + this.nyear()
      const suffixYear = startYear === endYear ? "" : endYear
      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)
      switch (this.type) {
        case 'month':
          return `${startYear}${startMonth}`
        case 'week':
          return `${startYear}${startMonth}${startDay} - ${suffixYear}${suffixMonth}${endDay}`
        case 'day':
          return `${startYear}${startMonth} ${startDay}`
      }
      return ''
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    }
  },
  mounted() {
    this.$refs.calendar.checkChange();
    const focusDate = this.$storage.getFocusDate()
    if (focusDate !== null && focusDate !== 'NaN') {
      const formattedDate = this.$util.formatDate(new Date(parseInt(focusDate)), false)
      this.focus = formattedDate
      this.updateList(formattedDate)
    }
  },
  methods: {
    // calendar
    viewDay ( { date } ) {
      this.updateList(date);
      const viewDate = new Date(date)
      this.$storage.setFocusDate(viewDate.getTime())
    },
    getEventColor(event) {
      return this.getMenuColor(event.nutrients)
    },
    setToday() {
      const now = new Date()
      this.today = this.$util.formatDate(now, false)
      this.focus = this.$util.formatDate(now, false)
      this.$storage.setFocusDate(now.getTime())
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    // /calendar

    // action
    updateRange({ start, end }) {
      const events = this.$storage.getAllMenu();
      this.start = start;
      this.end = end;
      this.events = events;
    },
    updateList(date) {
      const hasNutrients = [];
      const dateNutrients = [];
      const dateItems = [];

      this.events.forEach((_, idx) => {
        const start = this.events[idx].start
        if (start.indexOf(date) != -1) {
          dateItems.push(this.events[idx])
          this.events[idx].nutrients.forEach((_, nIdx) => {
            if (!hasNutrients.includes(this.events[idx].nutrients[nIdx])) {
              hasNutrients.push(this.events[idx].nutrients[nIdx])
              dateNutrients.push({
                id: this.events[idx].nutrients[nIdx],
                color: this.$nutrients.getColor(this.events[idx].nutrients[nIdx]),
                icon: this.$nutrients.getIcon(this.events[idx].nutrients[nIdx])
              });
            }
          });
        }
      })
      // 昇順にする
      dateItems.sort(function (a, b) {
        if (a.start < b.start) {
          return -1
        } else {
          return 1
        }
      })
      this.dateItems = dateItems;
      this.dateNutrients = dateNutrients;
    },
    // /action

    // baby

    getBabyData () {
      const babyData = this.$storage.getBabyData()
      if (babyData === null) {
        if (this.$route.name !== 'Config') {
          this.$router.push({ name: 'Config' })
          return null
        } else {
          return null
        }
      }
      return babyData
    },
    getName () {
      const babyData = this.getBabyData()
      return babyData !== null ? babyData.name + this.$gender.getSuffix(babyData.gender) : ''
    },
    getAgeMonth () {
      const babyData = this.getBabyData()
      if (babyData === null) {
        return ''
      }
      const dobDate = new Date(babyData.dob)
      const now = new Date()
      const lastOfBirth = new Date(dobDate.getFullYear(), dobDate.getMonth() + 1, 0)
      const diffMonth = now.getDate() < dobDate.getDate() ?
        now.getMonth() - dobDate.getMonth() - 1
        : now.getMonth() - dobDate.getMonth()
      const diffDay = dobDate.getDate() <= now.getDate() ?
        now.getDate() - dobDate.getDate()
        : (lastOfBirth.getDate() - dobDate.getDate()) + now.getDate() + 1
      return '(' + diffMonth + 'ヶ月' + diffDay + '日)'
    },
    // /baby

    // utility
    nth() {
      return '日'
    },
    nyear() {
      return '年'
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getMenuColor(nutrients) {
      let color = "";
      nutrients.forEach((_, idx) => {
        color = color === "" ? this.$nutrients.getColor(nutrients[idx]) : color;
      })
      return color
    },
    formatAmount(item) {
      return this.$units.formatUnit(item.unit, item.amount)
    },
    formatFocus() {
      // const focusParts = this.focus.split('-')
      // return focusParts[0] + '年' + focusParts[1] + '月' + focusParts[2] + '日'
      return this.$util.formatJpDate(new Date(parseInt(this.$storage.getFocusDate())), false)
    },
    hasFocus () {
      return this.$storage.getFocusDate() !== null
    }
    // /utility
  }
};
</script>
<style>
.v-event.v-event-start.v-event-end.white--text > div > strong {
  display: none
}
.v-calendar-weekly__week {
  flex: unset !important;
  min-height: 50px !important;
}
</style>
